const {jQuery: $} = window;
import Utils from "./utils.class";
import Cookies from 'js-cookie';
import  '../lib/mmenu';
import {iframeResize} from "iframe-resizer"

export default class Theme {
    $main;
    #html;
    #body;
    #header;
    #firstElement;
    #builder;
    #config;
    #scrollOffset;
    #scrollSpeed;
    #utils;
    #admin;
    #root;
    #cmp;

    #counter;
    #topHeader;

    constructor(
        config,
        builder,
        utils,
    ) {
        this.#config = config;
        this.#builder = builder;
        this.#utils = utils;
        this.#scrollOffset = 0;
        this.#root = document.querySelector(":root");

        this.#scrollSpeed = 750;
        this.#html = $('html');

        this.#body = $('body');
        this.$main = $('.site-wrapper');
        this.#header = $('header.elementor-location-header');
        this.#firstElement = $('header + div.elementor > div.elementor-element');
        this.#admin = $('#wpadminbar');
        this.#counter = $('.counter__number');
        this.#topHeader = $('.headerTop');

        if (window.location.hash === "#dev") {
            Cookies.set("debug", "1");
        }

        Utils.log("Theme Config:", config);

    }

    __onReady() {
        const me = this;

        Utils.log("Theme Ready");

        let pardotLeadCheck = false;
        window.addEventListener("message", function (event) {

            if (event.origin !== "https://go.partech.com") return;

            let message = false;
            try {
                message = JSON.parse(event.data);
            } catch (e) {
            }

            if (!pardotLeadCheck && message && (message.type === "pardot-form-submitted" || message.type === "resource-download")) {
                window.dataLayer = dataLayer || [];
                pardotLeadCheck = true;

                setTimeout(() => pardotLeadCheck = false, 10000); // throttle duplicate messages from the same form, not sure why this happens.

                const utm_campaign = Utils.URLSearchParams.get('utm_campaign');
                const utm_source = Utils.URLSearchParams.get('utm_source');
                const utm_medium = Utils.URLSearchParams.get('utm_medium');
                const utm_term = Utils.URLSearchParams.get('utm_term');
                const utm_content = Utils.URLSearchParams.get('utm_content');
                const utm_id = Utils.URLSearchParams.get('utm_id');

                dataLayer.push({
                    event: 'pardotLead',
                    pardotLead: {
                        pageURL: window.location.origin + window.location.pathname,
                        utm_campaign: utm_campaign || "",
                        utm_source: utm_source || "",
                        utm_medium: utm_medium || "",
                        utm_term: utm_term || "",
                        utm_content: utm_content || "",
                        utm_id: utm_id || ""
                    },
                });
            }
        });

        // Link to Pardot iframes
        $(".pardot-form").each(function (i, el) {
            const $el = $(el);
            const campaign = encodeURI(Utils.URLSearchParams.get("utm_campaign") || "");
            const source = encodeURI(Utils.URLSearchParams.get("utm_source") || "");
            const medium = encodeURI(Utils.URLSearchParams.get("utm_medium") || "");
            const term = encodeURI(Utils.URLSearchParams.get("utm_term") || "");
            const content = encodeURI(Utils.URLSearchParams.get("utm_content") || "");
            const GCLID = encodeURIComponent(Cookies.get("gclid") || "");
            const url = $el.data("url") + `?UTM_Campaign=${campaign}&UTM_Source=${source}&UTM_Medium=${medium}&UTM_Content=${content}&UTM_Term=${term}&GCLID=${GCLID}`;

            $el.attr("data-src-cmplz", url);

            if(cmplz_has_consent && cmplz_has_consent("marketing")) {
                $el.attr("src", url);
            }

            $el.removeClass("loading");
        });

        setTimeout(function () {
            const frame = iframeResize({log: Utils.debug, scrolling: false, checkOrigin: false}, ".resource--form__embed iframe, .embedded-form iframe");
            setInterval(frame.resize, 1000);
        }, 1);

        $('.js--hide-while-loading').removeClass('js--hide-while-loading');
    }

    __onLoad() {
        const me = this;

        Utils.log("Theme Load");
        this.#admin = $('#wpadminbar');

        var menu = new window.Mmenu("#menu-wrapper", {
            "offCanvas": {
                "position": "right-front",
            },
            "theme": "light",
        }, {
            "offCanvas": {
                "page": {
                    "selector": "#site-wrapper"
                }
            }
        });

        $('.mmenu-nav').on('click', function (evnt) {
            evnt.preventDefault();
            menu.API.open()
        })

        $(".html_menu .menu > .menu-item-has-children").on("mouseenter", function() {
            const $this = $(this);
            const $parent = $this.parents(".menu");
            $parent.find(".js-active").removeClass("js-active");
            $this.addClass("js-active");

            const menuWatcher = setInterval(() => {
                if(!$this.is(":hover")) {
                    $this.removeClass("js-active");
                    clearInterval(menuWatcher);
                }
            }, 2000);
        });
    }

    __onResize() {
        this.#updateCssHeaderHeight();
    }

    activatePlayer() {
        // TODO: Implement video platform integration
    }

    optIn(type) {
        cmplz_set_consent(type, 'allow');
        $("body").addClass(`cmplz-${type}`);
    }

    get utils() {
        return Utils;
    }

    get headerHeight() {
        if (this.#admin.length > 0) {
            return this.#header.outerHeight() + this.#admin.outerHeight();
        }

        return this.#header.outerHeight();
    }

    get CMP() {
        return this.#cmp;
    }

    #updateCssHeaderHeight() {
        this.#root.style.setProperty('--header-height', this.headerHeight + "px");
    }
}